import {
	Button,
	Input,
	Select,
} from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import Icon from '../Icon/Icon';
import Popup from '../Popup/Popup';
import useCreateSurvey from './useCreateSurvey';
import { Props } from './CreateSurvey.model';
import styles from './CreateSurvey.module.scss';
import AddRespondents from '../AddRespondents/AddRespondents';

const CreateSurvey = ({ onClose }: Props) => {
	const {
		addAllRespondents,
		addRespondent,
		control,
		errors,
		handleSubmit,
		onCreateSurvey,
		toggleAddRespondentPopup,
		removeRespondent,
		setSearchName,
		state: { members, participants, openAddRespondent },
	} = useCreateSurvey({ onClose });
	const intl = useIntl();

	const { Option } = Select;

	return (
		<>
			<Popup
				actions={
					<>
						<Button size="large" onClick={onClose}>
							<FormattedMessage id="buttons.cancel" />
						</Button>
						<Button
							size="large"
							type="primary"
							onClick={handleSubmit(onCreateSurvey)}
						>
							<FormattedMessage id="buttons.sendSurvey" />
						</Button>
					</>
				}
				size="large"
				title={{ target: 'createSurvey' }}
				onClose={onClose}
			>
				<div className={styles.wrapper}>
					<div className={styles.container}>
						<div className={styles.sectionTitle}>
							<Icon
								name="file-alt"
								color="light"
								width="18"
								height="18"
								className={styles.icon}
							/>
							<h2>
								<FormattedMessage id="createSurvey.links" />
							</h2>
						</div>
						<div className={styles.fieldWrapper}>
							<label className={styles.floatingLabel}>
								<FormattedMessage id="formLabels.surveyType" />
							</label>
							<Controller
								name="surveyType"
								control={control}
								render={({ field }) => (
									<Select
										{...field}
										placeholder={intl.formatMessage({
											id: `formPlaceholders.surveyType`,
										})}
										style={{ width: '100%' }}
									>
										<Option value={'QualityOfMentoringRelationship'}><FormattedMessage id="surveyType.QualityOfMentoringRelationship" /></Option>
										<Option value={'QualityOfPlatformFunctionality'}><FormattedMessage id="surveyType.QualityOfPlatformFunctionality" /></Option>
									</Select>
								)}
								rules={{ required: true }}
							/>
						</div>
						<div className={styles.fieldWrapper}>
							<label className={styles.floatingLabel}>
								<FormattedMessage id="formLabels.surveyLink" />
							</label>
							<Controller
								name="surveyLink"
								control={control}
								render={({ field }) => (
									<Input
										{...field}
										className={errors['title'] && 'error'}
										placeholder={intl.formatMessage({
											id: `formPlaceholders.surveyLink`,
										})}
									/>
								)}
								rules={{ required: true }}
							/>
						</div>
					</div>
					<div className={styles.container}>
						<div className={styles.respondentsContainer}>
							<div>
								<div className={styles.sectionTitle}>
									<Icon
										name="user-tie"
										color="light"
										width="18"
										height="18"
										className={styles.icon}
									/>
									<h2>
										<FormattedMessage id="createSurvey.respondents" />
									</h2>
								</div>
							</div>
							<div className={styles.addRespondentsContainer}>
								<Button
									type="text"
									size={'small'}
									onClick={toggleAddRespondentPopup}
								>
									<span
										style={{ color: '#50BEE3', textDecoration: 'underline' }}
									>
										<FormattedMessage id="buttons.addRespondents" />
									</span>
								</Button>
							</div>
						</div>
						<div className={styles.attendantsColumnsContainer}>
								{participants.map((item, index) => (
									<div key={`leftParticipantNr${index}`} className={styles.attendantsColumn}>
										<span>{item.firstName} {item.lastName}</span>
										<span className={styles.iconContainer} onClick={removeRespondent.bind(null, item)}>
												<Icon name="times" color="red" width="16px" height="16px"/>
											</span>
									</div>
								))}
							</div>
						</div>
					</div>
			</Popup>
			{openAddRespondent && (
				<AddRespondents
					onClose={toggleAddRespondentPopup}
					addRespondent={addRespondent}
					respondents={members}
					addAllRespondents={addAllRespondents}
					onSearchByTerm={setSearchName}
				/>
			)}
		</>
	);
};

export default CreateSurvey;
